export const programConfig = {
    live: {
        futbol: {
            "karma": {
                marketGroupId: 3,
                limit: 7,
                pinLimit: "1",
                widths: {
                    info: "490px",
                    markets: "1410px"
                },
                eventClass: "small"
            },
            "ilk-yari-13": {
                marketGroupId: 3,
                limit: 13,
                pinLimit: "7",
                widths: {
                    info: "580px",
                    markets: "1320px"
                },
                eventClass: "small",
                overrideSettings: {
                    goalEffect: true
                }
            },
            "mac-genel-13": {
                marketGroupId: 4,
                limit: 13,
                pinLimit: "7",
                widths: {
                    info: "580px",
                    markets: "1320px"
                },
                eventClass: "small",
                overrideSettings: {
                    goalEffect: true
                }
            },
            "mac-genel-7": {
                marketGroupId: 1,
                limit: 7,
                pinLimit: "4",
                widths: {
                    info: "550px",
                    markets: "1350px"
                },
                eventClass: "big",
                overrideSettings: {
                    goalEffect: true
                }
            },
            "gol-oyunlari-7": {
                marketGroupId: 2,
                limit: 7,
                pinLimit: "4",
                widths: {
                    info: "550px",
                    markets: "1350px"
                },
                eventClass: "big",
                overrideSettings: {
                    goalEffect: true
                }
            }
        },
        basketbol: {
            "karma": {
                marketGroupId: 3,
                limit: 7,
                pinLimit: "1",
                widths: {
                    info: "660px",
                    markets: "1240px"
                },
                eventClass: "small"
            },
            "ilk-yari-13": {
                marketGroupId: 1,
                limit: 13,
                pinLimit: "7",
                widths: {
                    info: "660px",
                    markets: "1240px"
                },
                eventClass: "small"
            },
            "mac-genel-13": {
                marketGroupId: 3,
                limit: 13,
                pinLimit: "7",
                widths: {
                    info: "660px",
                    markets: "1240px"
                },
                eventClass: "small"
            },
            "ilk-yari-10": {
                marketGroupId: 2,
                limit: 10,
                pinLimit: "5",
                widths: {
                    info: "550px",
                    markets: "1350px"
                },
                eventClass: "middle"
            },
            "mac-genel-10": {
                marketGroupId: 4,
                limit: 10,
                pinLimit: "5",
                widths: {
                    info: "550px",
                    markets: "1350px"
                },
                eventClass: "middle"
            }
        },
        voleybol: {
            "karma": {
                pinLimit: "1",
                widths: {
                    info: "560px",
                    markets: "1340px"
                },
                eventClass: "small"
            },
            limit: 7,
            pinLimit: "4",
            marketGroupId: 1,
            widths: {
                info: "560px",
                markets: "1340px"
            },
            eventClass: "middle"
        },
        tenis: {
            "karma": {
                pinLimit: "1",
                widths: {
                    info: "560px",
                    markets: "1340px"
                },
                eventClass: "middle"
            },
            marketGroupId: 1,
            limit: 7,
            pinLimit: 4,
            widths: {
                info: "560px",
                markets: "1340px"
            },
            eventClass: "middle"
        }
    },
    fixture: {
        futbol: {
            "yaklasan-maclar-8": {
                limit: 8,
                pinLimit: "4",
                widths: {
                    info: "380px",
                    markets: "1550px"
                },
                eventClass: "middle2"
            },
            "yaklasan-maclar-11": {
                limit: 11,
                pinLimit: "6",
                widths: {
                    info: "380px",
                    markets: "1550px"
                },
                eventClass: "small2"
            }
        },
        basketbol: {
            "yaklasan-maclar-8": {
                limit: 8,
                pinLimit: "4",
                widths: {
                    info: "380px",
                    markets: "1550px"
                },
                eventClass: "middle2"
            },
            "yaklasan-maclar-11": {
                limit: 11,
                pinLimit: "6",
                widths: {
                    info: "380px",
                    markets: "1550px"
                },
                eventClass: "small2"
            }
        },
        voleybol: {
            limit: 11,
            pinLimit: "6",
            marketGroupId: 1,
            widths: {
                info: "330px",
                markets: "1590px"
            },
            eventClass: "middle"
        },
        tenis: {
            limit: 11,
            pinLimit: "6",
            marketGroupId: 1,
            widths: {
                info: "340px",
                markets: "1550px"
            },
            eventClass: "middle"
        }
    },
    liveResults: {
        overrideSettings: {
            matchTimeRange: false
        }
    },
    matchResults: {}
};

export const PIN_REMOVE_TIME = 86400000; // 1 gün
export const RELOAD_PAGE_TIME = 60 * 1000; // 1 Dakika
